import { gql } from "@apollo/client";

export const VALIDATE_MANUALLY = gql`
  mutation validateManually($input: ValidateManuallyInvoiceInput!) {
    invoice {
      validateManually(input: $input) {
        success
      }
    }
  }
`;
